import React from 'react';
import { Typography } from '@mui/material';
import './IntroPageQ42024.css' // Import the stylesheet


//logos
import cascdrLogo from '../../media/images/cascdr/CASCDR.webp';
import cascdrTitle from '../../media/images/cascdr/cascdr_name_only.webp';
import logicAppPreview from '../../media/images/cascdr/logic-app-preview-main-page.webp'
import CarouselComponent from '../../common/components/CarouselComponent';
import SquareAppGrid from '../../common/components/menus/SquareAppGrid';

import gptLogo from '../../media/images/services/gpt-icon.svg';
import jamieLogo from '../../media/images/services/jamie-logo-final.png';
import TestimonialsGrid from '../../common/components/menus/TestimonialsGrid';
import ContactUsSection from '../../common/components/menus/ContactUsSection';

//Testimonials
import gentryImage from '../../media/images/demo/ryan-gentry-headshot.png'
import keysImage from '../../media/images/demo/brandon-keys-headshot.jpeg'
import tftcImage from '../../media/images/demo/tftc-logo.webp'
import cascdrOnBlack from '../../media/images/misc/cascdr-placeholder.png'

//Contact info
import EmailIcon from '../../media/images/misc/email-icon.png';
import XIcon from '../../media/images/misc/x-icon.png';
import SNIcon from '../../media/images/misc/sn-icon.png';
import NostrIcon from '../../media/images/misc/nostr-icon.png'



const IntroPageQ42024 = () => {
    const allAppsArray = [
        {
          pageName: 'CHATGPT3.5 PROXY',
          description: 'Chat with ChatGPT 3.5 without making an account. Privacy first AI.',
          image: gptLogo,
          background: 'bg-gradient-to-r from-[#f8801e] to-[#f84c1e]',
          link: 'GPT',
        },
        {    
          pageName: 'JAMIE MEDIA ASSISTANT',
          description: 'Transcribe media & instantly create content with AI',
          image: jamieLogo,
          background: 'bg-gradient-to-r from-[#f8801e] to-[#f84c1e]',
          link: 'jamie',
      },
    ];

    const testimonials = [
      {
        text: '"[CASCDR] demonstrates how services integrated into a workflow and combined into a whole application can be greater than the sum of the parts."',
        name: "Ryan Gentry",
        role: "Head of BD at Lightning Labs",
        image: gentryImage
      },
      {
        text: '"CASCDR has helped Green Candle cut back on the amount of time it takes to put out quality content. It has given me more time to be creative, focus on quality, and continue to put out content in a timely manner."',
        name: "Brandon Keys",
        role: "Host of Green Candle Investments",
        image: keysImage
      },
      {
        text: '"CASCDR\'s PullThatUpJamie.ai tool has helped us save tons of time and get more done. I highly recommend it."',
        name: "Trevor",
        role: "Social Media Manager @ TFTC",
        image: tftcImage
      },
      // Add more testimonials as needed
    ];
    const missionStatement = [
      {
        text: '"Use AI and Bitcoin tools to empower the individual. To help users get the most out of the productivity gains from the AI Revolution and to enrich their lives while preserving their privacy and respecting their beliefs, wishes and sovereignty. Furthermore, we want to empower a decentralized network of innovators to create value in the AI space and earn accordingly."',
        name: "CASCDR",
        role: "Mission Statement",
        image: cascdrOnBlack
      },
    ];

    const contactLinks = [
      { name: 'Twitter', icon: XIcon, url: 'https://twitter.com/cascdr_' },
      { name: 'Stacker News', icon: SNIcon, url: 'https://stacker.news/cascdr' },
      { name: 'Nostr', icon: NostrIcon, url: 'https://primal.net/p/npub14pfjj6jf8y702pdjar2q36ve5r4t2gu2lp4yma00j49jkgy7d90swg7mwj' },
      { name: 'Email', icon: EmailIcon, url: 'mailto:jim@cascdr.xyz' },
    ];
    
    return (
        <div className="intro-container">
          <div className="content-wrapper">
            <div className="intro-content">
              <img src={cascdrLogo} alt="CASCDR Logo" className="logo" />
              <img src={cascdrTitle} alt="CASCDR" className="title-logo" />
              <div className="subtitle-preview-wrapper">
                <Typography 
                  variant="h5" 
                  component="h2" 
                  className="subtitle"
                  sx={{ 
                    fontWeight: 400, 
                    fontSize:'34px',
                  }}
                >
                  Private Bitcoin Payable AI Services.
                </Typography>
              </div>
              <div className="preview-container">
                <img src={logicAppPreview} alt="CASCDR" className="logic-app-preview" />
              </div>
            </div>
            <div className="apps-section">
              <CarouselComponent title="Featured apps" />
              <SquareAppGrid appData={allAppsArray} title="All Apps" />
              <TestimonialsGrid title="Our Mission" testimonials={missionStatement} />
              <TestimonialsGrid title="Testimonials" testimonials={testimonials}/>
            </div>
            <ContactUsSection title="Contact Us" links={contactLinks} />
          </div>
        </div>
    );
};

export default IntroPageQ42024;
